import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/query-keys.ts'
import { fetchConversation, fetchConversations, fetchSupportStats, type ConversationFilters } from './api.ts'

export function useConversations(filters: ConversationFilters) {
  return useQuery({
    queryKey: queryKeys.supportConversations(filters),
    queryFn: ({ signal }) => fetchConversations(filters, signal),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  })
}

export function useConversation(id: string | null) {
  return useQuery({
    queryKey: queryKeys.supportConversation(id ?? ''),
    queryFn: ({ signal }) => fetchConversation(id as string, signal),
    enabled: Boolean(id),
    staleTime: 60 * 1000,
  })
}

export function useSupportStats() {
  return useQuery({
    queryKey: queryKeys.supportStats,
    queryFn: ({ signal }) => fetchSupportStats(signal),
    staleTime: 60 * 1000,
  })
}
